export default __webpack_public_path__ + "static/media/how-youre-feeling.73bc3a80.svg";